import { connect } from 'react-redux'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useLocalizedBreadcrumbs } from 'hooks/usePlace'
import OfferBreadcrumbTrail from './OfferBreadcrumbTrail'

interface Props {
  offer?: App.Offer | App.BedbankOffer
  relatedTravelItems?: Array<App.BreadcrumbItem>
}

function DesktopRelatedTravelItems({ relatedTravelItems = EmptyArray }: Props) {
  const localizedItems = useLocalizedBreadcrumbs(relatedTravelItems)
  return <OfferBreadcrumbTrail items={localizedItems} />
}

function mapStateToProps(state: App.State, ownProps: Props) {
  return {
    relatedTravelItems: ownProps.relatedTravelItems ?? state.offer.relatedTravelItems[ownProps.offer?.id ?? ''],
  }
}

export default connect(mapStateToProps)(DesktopRelatedTravelItems)
